import React, { Fragment } from 'react';
import kebabCase from 'lodash/kebabCase';

import { Campaign } from '@domain/campaigns';
import ColorConstants from '../../../constants/ColorConstants';

import RoundedSquareWithLabel from '../../layouts/RoundedSquareWithLabel';
import TEST_IDS from '../../../utils/_tests/testIds.constants';
import {
    AccordionItemContent,
    DefaultRenderComponent,
    renderMenuContent,
} from './accordion.styles';

const roundedSquareWithLabelStyles = {
    'justify-content': 'flex-start',
    'padding-right': '75px',
    'margin-bottom': '5px',
    'background-color': ColorConstants.white,
    'min-width': '200px',
};

interface Props{
    item: any,
    activeItem: any,
    setActiveItem: (id?: string) => void,
    onChange: (
        tag: {label: string, value: string},
        campaign: Campaign,
        isCreating: boolean,
    ) => void,
    renderContent: (props: any) => void,
}

const RoundedSquareAccordionItem = ({
    item,
    activeItem,
    setActiveItem,
    onChange,
    renderContent = DefaultRenderComponent,
}: Props) => {
    const {
        id,
        label,
        labelColor,
        subitems,
        content,
        subtitle,
    } = item;
    const isItemActive = activeItem === id;

    return (
        <Fragment>
            <RoundedSquareWithLabel
                label={label}
                labelStyle={{ color: labelColor, opacity: 1 }}
                styles={{
                    ...roundedSquareWithLabelStyles,
                    'background-color': ColorConstants['white-smoke'],
                }}
                onClick={() => (
                    isItemActive ? setActiveItem(null) : setActiveItem(id)
                )}
            >
                {renderMenuContent(content, subtitle)}
            </RoundedSquareWithLabel>
            <AccordionItemContent isVisible={isItemActive}>
                { subitems.map((subItem) => {
                    const value = subItem.content === '' ? null : subItem.content?.toString();

                    if (subItem.customRenderer) {
                        return subItem.customRenderer(subItem);
                    }

                    function handleChangeOrCreateTag(tag, isCreating) {
                        return onChange(
                            tag.value,
                            subItem.campaign,
                            isCreating,
                        );
                    }
                    return (
                        <RoundedSquareWithLabel
                            spanTitle={subItem.spanTitle}
                            label={subItem.label}
                            styles={{
                                ...roundedSquareWithLabelStyles,
                            }}
                            key={`order-${subItem.order}`}
                            testId={TEST_IDS.ACCORDION.ACCORDION_ITEM}
                        >
                            {renderContent({
                                value: value || subItem.value,
                                defaultValue: value || subItem.value,
                                onChange: event => handleChangeOrCreateTag(
                                    event === null ? [] : event,
                                    false,
                                ),
                                onCreateOption: newOption => handleChangeOrCreateTag(
                                    { label: newOption, value: kebabCase(newOption) },
                                    true,
                                ),
                                style: { minWidth: '200px' },

                            })}
                        </RoundedSquareWithLabel>
                    );
                })}

            </AccordionItemContent>
        </Fragment>
    );
};


export default RoundedSquareAccordionItem;
